import React from 'react';
import { GameType } from '../../../types/GameType.ts';
import WeaverYesterdayModal from './WeaverYesterdayModal.tsx';
import SubtextYesterdayModal from './SubtextYesterdayModal.tsx';

interface YesterdayModalProps {
  isOpen: boolean;
  onClose: () => void;
  gameType: GameType;
}

const YesterdayModal: React.FC<YesterdayModalProps> = (props) => {
  const { gameType, ...commonProps } = props;
  
  switch (gameType) {
    case GameType.WEAVER:
    case GameType.WEAVER_X:
      return <WeaverYesterdayModal {...commonProps} gameType={gameType} />;
    case GameType.SUBTEXT:
      return <SubtextYesterdayModal {...commonProps} />;
    default:
      // This should never happen with proper typing, but good to have a fallback
      return null;
  }
};

export default YesterdayModal; 